import { render, staticRenderFns } from "./ReportSort.vue?vue&type=template&id=bfa9e28a&"
import script from "./ReportSort.vue?vue&type=script&lang=js&"
export * from "./ReportSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports